module.exports = __webpack_public_path__ + "static/hacibaba-web-701126bd27eae86f2f863f14e69c1515.jpg";